import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '../layoutservice';
import { AuthService } from '@modules/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  activeMenuItem: string = '';
  menuItemsCopy!: any;
  submenuTimeout: any;
  menuItems: any[] = [];
  userRole: string | null = null;

  constructor(private router: Router, private layoutService: LayoutService, private authService: AuthService) { }

  ngOnInit(): void {
    this.userRole = this.authService.getUserRole();
    this.buildMenuItems();
    this.menuItemsCopy = this.menuItems;
    this.layoutService.sendMenuItems(this.menuItems);
  }

  buildMenuItems() {
    const allMenus = [
      {
        name: "Dashboard",
        id: "Dashboard",
        url: "/dashboard/dashboard",
        icon: "assets/images/dashboard.svg",
        hasAccess: true,
        statussub: true,
        lastmenu: false,
        isExternal: false,
        showSubmenu: false,
        submenuitem: [
          { name: "My Dashboard", link: "/dashboard", isExternal: false }
        ]
      },
      {
        name: "User",
        id: "User",
        url: "/dashboard",
        icon: "assets/images/admin.svg",
        hasAccess: true,
        statussub: true,
        lastmenu: false,
        isExternal: false,
        showSubmenu: false,
        submenuitem: [
          { name: "Manage User", link: "/user/listing", isExternal: false },
        ]
      },
      {
        name: "Customer",
        id: "Customer",
        url: "/dashboard",
        icon: "assets/images/customer.svg",
        hasAccess: true,
        statussub: true,
        lastmenu: false,
        isExternal: false,
        showSubmenu: false,
        submenuitem: [
          { name: "Manage Customer", link: "/customer/listing", isExternal: false },
        ]
      },
      {
        name: "Quotation",
        id: "Quotation",
        url: "/dashboard",
        icon: "assets/images/quotation.svg",
        hasAccess: true,
        statussub: true,
        lastmenu: false,
        isExternal: false,
        showSubmenu: false,
        submenuitem: [
          { name: "Manage Quotation", link: "/quotation/listing", isExternal: false },
        ]
      },
      {
        name: "Utilities",
        id: "Utilities",
        url: "/dashboard",
        icon: "assets/images/utilities.svg",
        hasAccess: true,
        statussub: true,
        lastmenu: false,
        isExternal: false,
        showSubmenu: false,
        submenuitem: [
          { name: "Manage Vehicle", link: "/vehicle/listing", isExternal: false },
          { name: "Manage Insurance", link: "/insurance/listing", isExternal: false },
          { name: "Manage Company", link: "/company/listing", isExternal: false },
          { name: "WhatsApp Template", link: "/template/whatsapp/listing", isExternal: false },
          { name: "Email Template", link: "/template/email", isExternal: false },
        ]
      },
    ];

    const selectedRole = [
      {
        name: "Dashboard",
        id: "Dashboard",
        url: "/dashboard/dashboard",
        icon: "assets/images/dashboard.svg",
        hasAccess: true,
        statussub: true,
        lastmenu: false,
        isExternal: false,
        showSubmenu: false,
        submenuitem: [
          { name: "My Dashboard", link: "/dashboard", isExternal: false }
        ]
      },
      {
        name: "Quotation",
        id: "Quotation",
        url: "/dashboard",
        icon: "assets/images/quotation.svg",
        hasAccess: true,
        statussub: true,
        lastmenu: false,
        isExternal: false,
        showSubmenu: false,
        submenuitem: [
          { name: "Manage Quotation", link: "/quotation/listing", isExternal: false },
        ]
      }
    ];
    this.menuItems = (this.userRole === 'Sale' || this.userRole === 'Agent') ? selectedRole : allMenus;
  }

  setActiveMenuItem(item: string, subMenu: any) {
    this.activeMenuItem = item;
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    this.router.navigate([subMenu.link]);
  }

  showSubmenu(item: any) {
    clearTimeout(this.submenuTimeout);
    item.showSubmenu = true;
  }

  hideSubmenu(item: any) {
    this.submenuTimeout = setTimeout(() => {
      item.showSubmenu = false;
    }, 200);
  }

  stayOpen(item: any) {
    clearTimeout(this.submenuTimeout);
    item.showSubmenu = true;
  }
}